// extracted by mini-css-extract-plugin
export default {"content":"PaymentConfirmationPage_content__4cfY8 sectionPadding","contentWrapper":"PaymentConfirmationPage_contentWrapper__5d-f2"};